import React,{Component} from 'react'
import {Helmet} from "react-helmet"

export default class Head extends Component{
  render(){
    const {title} = this.props;
    return(
      <Helmet>
        <title>{title}</title>
      </Helmet>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Head.js